import {
  LOGGED_OUT_OPTS,
  gtmPush,
  gtmEvent,
  mapUrlOrigin,
  segment,
  urlOriginMapArray,
} from './helpers'
import services from '../config/services'

// SEGMENT

// creates a unqiue id based of the user's id and associates that with the
//  user's email address
// called at the beginning of every full refesh (for logged in users) OR
//  when a user logs in or registers
const identify = (id, email) =>
  window.analytics.identify(`${services.SEGMENT_USER_ID_PREFIX}${id}`, {
    email,
  })

/**
 * Identifies an anonymous, non-logged-in user to Segment. They create a temporary,
 * unique ID for traking until we obtain logged-in details.
 *
 * @param {Object}  traits An object of user traits
 * @param {Boolean} traits.isPrerenderUser If we've identified this user as a Prerender bot
 */
export const unauthenticatedUser = (traits) => window.analytics.identify(traits, LOGGED_OUT_OPTS)

// mimics these historically backend-reported events which track of user login
//  and registration
// these events will coexist for at least a year, so we can have accurate YoY
//  reports
export const login = (payload) => segment('login Client', payload)
export const registration = (payload) =>
  segment('registration Client', {...payload, origin: mapUrlOrigin(urlOriginMapArray)})

// GTM

// NOTE: the below strings are enums not just for our repo but inside gtm triggers
//  and tags!
export const AUTH_TYPE = {
  ALREADY_AUTHENTICATED: 'alreadyAuthenticated',
  LOGIN: 'login',
  REGISTRATION: 'registration',
}

// will be used first to initialize Snapchat tracking and report SIGN_UPs, but
//  could be used by other triggers and tags!
const authenticated = (id, email, authType) => {
  gtmPush({
    user: {
      authType,
      email,
      id,
    },
  })
  gtmEvent('authenticated', {
    authType,
    email,
    id,
  })
}

// BOTH

// calls gtm and segment code
export const authenticatedUser = (id, email, authType) => {
  identify(id, email)
  authenticated(id, email, authType)
}
